import type { FaireBrandEntity } from "../../entity_types/brand";

// Anonymized stand-in for the p9_budget_capped archetype (real metrics, fake identity).
export const bAdvP9BudgetCapped: FaireBrandEntity = {
  token: "b_adv_p9_budget_capped",
  type: "brand",
  name: "Wildflower & Co.",
  description: "Boho bags, hats, and layered jewelry",
  location: "Nashville, TN",
  rating: 4.8,
  minimumOrderDollars: 150,
  tags: ["accessories", "bags", "jewelry"],
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
